import { render, staticRenderFns } from "./mafo.vue?vue&type=template&id=4b5b0b07&scoped=true"
import script from "./mafo.vue?vue&type=script&lang=js"
export * from "./mafo.vue?vue&type=script&lang=js"
import style0 from "./mafo.vue?vue&type=style&index=0&id=4b5b0b07&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b5b0b07",
  null
  
)

export default component.exports